import { z } from 'zod';
/** Minimum compliance percentage required for a PDF to be considered passing. */
export const PDF_COMPLIANCE_THRESHOLD = 95;
export const PDF_MIME_TYPE = 'application/pdf';
/** Upper bound on issues accepted in one report request. Real PDFs collapse to far fewer. */
const PDF_ISSUE_REPORT_MAX_ISSUES = 500;
const pdfIssueSchema = z.object({
    id: z.string().min(1),
    title: z.string(),
    severity: z.enum(['blocker', 'major', 'minor']),
    impact: z.string(),
    occurrences: z.number().int().nonnegative(),
    fix: z.string(),
    rawRule: z.object({
        specification: z.string(),
        clause: z.string(),
        testNumber: z.number().int(),
        description: z.string(),
    }),
});
export const pdfIssueReportSchema = z.object({
    filename: z
        .string()
        .trim()
        .min(1)
        .max(255)
        .describe('Name of the validated PDF. Used to name the downloaded CSV.'),
    issues: z.array(pdfIssueSchema).min(1).max(PDF_ISSUE_REPORT_MAX_ISSUES),
});
